import { makeStyles } from 'tss-react/mui';

/** Shared card look for the Basic Details tab — one continuous bordered card with a divider between each group. */
export const useSeriesDetailCardStyles = makeStyles()((theme) => ({
  tabContent: {
    width: '100%',
    display: 'flex',
    gap: theme.spacing(3),
    flexDirection: 'column',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius * 4,
    backgroundColor: theme.palette.background.paper,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    // padding: theme.spacing(3),
  },
  nameRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  payeeInput: {
    flex: 1,
    minWidth: 0,
    margin: 0,
    '& .MuiOutlinedInput-root': { padding: '2px 0px' },
    '& fieldset.MuiOutlinedInput-notchedOutline': {
      borderWidth: '1px !important',
      borderRadius: theme.spacing(1),
    },
    '& .MuiInputBase-root, & input': { cursor: 'text' },
    '&:not(:focus-within):not(:hover) fieldset': { border: 'none' },
    '&:hover:not(:focus-within)': {
      '& fieldset': { borderColor: theme.palette.primary.main },
      backgroundColor: theme.palette.action.hover,
    },
    '&:focus-within fieldset': {
      boxShadow: `0px 0px 0px 4px ${theme.palette.primary.light}`,
    },
    '& input': { fieldSizing: 'content', minWidth: '1ch' },
  },
  fieldRow: {
    display: 'flex',
    gap: theme.spacing(2),
  },
  halfWidthField: {
    flex: 1,
    minWidth: 0,
  },
  typeField: {
    maxWidth: 173,
  },
  splitsColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  typeSelect: {
    backgroundColor: theme.palette.background.default,
  },
  sectionHeader: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));
